import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { makeStyles } from '@mui/styles';
import helpers from 'src/styles/helpers';
import sections from 'src/styles/sections';
const useStyles = makeStyles(_objectSpread(_objectSpread(_objectSpread({}, helpers), sections), {}, {
  modalBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    minWidth: '360px'
  },
  addressRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  addressText: {
    fontFamily: 'monospace',
    fontSize: '14px',
    wordBreak: 'break-all',
    flex: 1
  },
  historyRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 0',
    borderBottom: '1px solid rgba(0, 0, 0, 0.08)'
  },
  graceNote: {
    fontSize: '13px',
    opacity: 0.7
  },
  tierLockNote: {
    fontSize: '14px',
    fontWeight: 500
  }
}));
export default useStyles;